import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Hexagon } from 'lucide-react';
import { API_BASE } from '../../config/api';
import { LabBadgeImage, useBadgeImage, downloadBadge } from '../labs/LabBadge';

const API = `${API_BASE}/api`;

function BadgeTile({ badge, token }) {
  const src = useBadgeImage(badge.badge_id, token);
  return (
    <button type="button" onClick={() => downloadBadge(src, badge.lab_title)} title="Download badge"
      className="group flex flex-col items-center text-center p-3 rounded-xl hover:bg-zinc-800/60 transition-colors" data-testid={`my-badge-${badge.badge_id}`}>
      <LabBadgeImage badge={badge} token={token} className="w-24 h-24 transition-transform duration-300 group-hover:scale-105" />
      <span className="mt-2 text-xs text-zinc-200 line-clamp-2">{badge.lab_title}</span>
      <span className="text-[11px] text-zinc-500">{new Date(badge.awarded_at).toLocaleDateString()}</span>
    </button>
  );
}

export default function MyBadgesSection({ token }) {
  const [badges, setBadges] = useState(null);
  useEffect(() => {
    if (!token) return;
    axios.get(`${API}/lab-badges/mine`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setBadges(r.data.badges || []))
      .catch(() => setBadges([]));
  }, [token]);
  if (!badges) return null;
  return (
    <section className="rounded-2xl border border-zinc-800 bg-zinc-900 p-5 mb-8" data-testid="my-badges-section">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-white font-semibold flex items-center gap-2"><Hexagon className="h-4 w-4 text-navigate-gold" />My Badges</h2>
        <span className="text-xs text-zinc-500" data-testid="my-badges-count">{badges.length} earned</span>
      </div>
      {badges.length === 0 ? (
        <p className="text-sm text-zinc-500" data-testid="my-badges-empty">Complete a Learning Lab with 50% or more to earn your first Navigate badge.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-6 gap-2">
          {badges.map((b) => <BadgeTile key={b.badge_id} badge={b} token={token} />)}
        </div>
      )}
    </section>
  );
}
